<script>
  import { _ } from "svelte-i18n"
  import { previews_storefronts_filter, previews_nav_filters, previews_font_size } from './../stores'
  import Button from '../elements/Button.svelte'
  import IconCloudDone from '../elements/IconCloudDone.svelte'
  
  export let font
  export let hovering_parent
  export let zoomed_parent

  $:is_loading = font.font_file_loading
</script>

{#if font.source === 'google' && $previews_nav_filters.selected && hovering_parent && !zoomed_parent}
  <div class="button_wrapper">
    <Button href="{font.url}" kind="outline" size="tiny">{$_('buttons.download')}</Button>
  </div>
{:else}
  <p
    class="fontname" 
    class:hovering_parent
    class:zoomed_parent
    class:is_loading
    class:has_uploaded_icon = {font.uploaded}
    class:faded = {$previews_font_size < 4 && !$previews_nav_filters.selected}
    class:tiny = {$previews_font_size < 2 && !$previews_nav_filters.selected}>
      {#if font.uploaded}
        <IconCloudDone/>
      {/if}
      {#if font.storefront && !!$previews_storefronts_filter}
        {#if font.storefronts.find(storefront => storefront.id == $previews_storefronts_filter)?.preferred_name && font.storefronts.find(storefront => storefront.id == $previews_storefronts_filter)?.preferred_name !== font.display_name}
          <em>{font.storefronts.find(storefront => storefront.id == $previews_storefronts_filter)?.preferred_name}</em><br>
          {#if is_loading}Loading {:else} ({font.display_name}) {/if}
        {:else}
          {font.display_name}<br>
          {#if is_loading}Loading {/if}
        {/if}
      {:else}
        {font.display_name}
      {/if}
  </p>
{/if}

<style>
  p {
    display: block;
    position: absolute;
    bottom: 1rem;
    max-width: calc(100% - 1rem);
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: var(--PensumSans);
    font-size: 1.3rem;
    line-height: 1.33em;
    letter-spacing: 0.02rem;
    color: var(--c-text-faded);
    text-decoration: none;
    white-space: nowrap;
  }
  p em {
    font-style: normal;
    color: var(--c-text);
  }
  p.has_uploaded_icon {
    padding: 0 2rem;
  }
  .button_wrapper {
    position: absolute;
    bottom: 1rem;
  }
  p:hover {
    z-index: 2;
    white-space: inherit;
    background-color: var(--c-content-bg);
  }
  .fontname {
    cursor: text;
  }
  .faded {
    opacity: 0.8;
  }
  .tiny {
    opacity: 0.66;
    font-size: 1.2rem;
    bottom: 0.4rem;
  }
  .zoomed_parent {
    bottom: 5rem;
    font-size: 1.9rem;
  }
  .zoomed_parent :global(.icon-cloud-done) {
    margin-right: 1rem;
  }
  .zoomed_parent :global(.icon-cloud-done .icon) {
    width: 3rem;
    height: 3rem;
  }
  .is_loading {
    animation: blink 1s infinite ease-in-out;
  }
  @keyframes blink {
    0%   { opacity:0.66; }
    50%  { opacity:0.33; }
    100% { opacity:0.66; }
  }
</style>